module.exports = __webpack_public_path__ + "static/assets/3e3dc0246b6d36dde6fe4b7e1eb1efcf.gif";